import React from "react";
import { getActivityByTable } from "../../config/activities";

/** One reservation row on the manage page, with actions for active reservations. */
const ReservationCard = ({ reservation, onChangeTime, onShowQr, onCancel }) => {
  const activity = getActivityByTable(reservation.table);
  const isActive = reservation.status === "active";
  const isCancelled = reservation.status === "cancelled";
  const className = ["res-card", isActive ? "active" : "", isCancelled ? "cancelled" : ""].join(" ").trim();

  return (
    <article className={className}>
      <div className="res-head">
        <h4>{reservation.teamName}</h4>
        <div className="meta">
          <span className="chip marigold">{activity?.shortName ?? reservation.table}</span>
          {isCancelled && <span className="chip danger">Zrušeno</span>}
        </div>
      </div>
      <div className="res-meta">
        <div>
          <b>Čas</b>
          {reservation.timeDisplay ?? reservation.time_slot}
        </div>
        <div>
          <b>Počet účastníků</b>
          {reservation.participantCount}
        </div>
      </div>
      {isActive && (
        <div className="res-actions">
          <button type="button" className="btn btn-sm btn-agua" onClick={onChangeTime}>
            Změnit čas
          </button>
          <button type="button" className="btn btn-sm btn-ghost" onClick={onShowQr}>
            QR kód
          </button>
          <button type="button" className="btn btn-sm btn-danger" onClick={onCancel}>
            Zrušit
          </button>
        </div>
      )}
    </article>
  );
};

export default ReservationCard;
